<template>
  <KarteUserListItemInformationText :class="$style.text"
    >マッチングの可能性が高い</KarteUserListItemInformationText
  >
</template>

<script lang="ts" setup>
import KarteUserListItemInformationText from '../KarteUserInformationText.vue'
</script>

<style lang="scss" module>
.text {
  color: $color-label-red;
}
</style>
